module.exports = __webpack_public_path__ + "static/img/case_banner_02_h5.5a21c1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_02_h5.png
// module id = e3Ar
// module chunks = 34